"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebPlatform = void 0;
var ua_parser_js_1 = __importDefault(require("ua-parser-js"));
var device_id_1 = require("../meta/device-id");
var DeviceIdPrefix = 'w-';
var DeviceIdKey = 'gsu-device-id';
var AuthTokenKey = 'auth.user';
var PartnerKey = 'auth.partner';
function WebPlatform(opts) {
    var _a;
    var uaParser = new ua_parser_js_1.default();
    var deviceIdGenerator = (_a = opts.deviceIdGenerator) !== null && _a !== void 0 ? _a : device_id_1.ULIDDeviceIDGenerator();
    function getStoredItemFromCookie(key) {
        return __awaiter(this, void 0, void 0, function () {
            var cookieItem, value;
            return __generator(this, function (_a) {
                if (document === null || document === void 0 ? void 0 : document.cookie) {
                    cookieItem = document.cookie.split(/;\s*/).find(function (item) { return item.startsWith(key + "="); });
                    if (!cookieItem) {
                        return [2 /*return*/, undefined];
                    }
                    value = cookieItem.split(/=/, 2)[1];
                    return [2 /*return*/, value];
                }
                return [2 /*return*/, undefined];
            });
        });
    }
    function getStoredItemFromLocalStorage(key) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var val;
            return __generator(this, function (_b) {
                if ((_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem) {
                    val = window.localStorage.getItem(key);
                    if (val === null) {
                        return [2 /*return*/, undefined];
                    }
                    return [2 /*return*/, val];
                }
                return [2 /*return*/, undefined];
            });
        });
    }
    function setStoredItemInLocalStorage(key, value) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                if ((_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.setItem) {
                    window.localStorage.setItem(key, value);
                }
                return [2 /*return*/];
            });
        });
    }
    function setStoredItemInCookies(key, value, domain, maxAgeSeconds, sameSite) {
        if (sameSite === void 0) { sameSite = 'lax'; }
        return __awaiter(this, void 0, void 0, function () {
            var cookie;
            return __generator(this, function (_a) {
                if (document) {
                    cookie = key + "=" + value + "; Domain=" + domain + "; path='/'; Max-Age=" + maxAgeSeconds + "; SameSite=" + sameSite;
                    // console.log('about to set cookie', cookie)
                    document.cookie = cookie;
                }
                return [2 /*return*/];
            });
        });
    }
    // memoize in this closure so that we don't have to get from storage every single time
    var deviceId = undefined;
    function getDeviceId(embeddedOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var deviceIdWasInCookies, deviceIdWasGenerated;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if ((embeddedOptions === null || embeddedOptions === void 0 ? void 0 : embeddedOptions.identifier) && (embeddedOptions === null || embeddedOptions === void 0 ? void 0 : embeddedOptions.deviceIdOverride)) {
                            return [2 /*return*/, embeddedOptions.deviceIdOverride];
                        }
                        if (deviceId) {
                            return [2 /*return*/, deviceId];
                        }
                        deviceIdWasInCookies = false;
                        return [4 /*yield*/, getStoredItemFromLocalStorage(DeviceIdKey)];
                    case 1:
                        deviceId = _a.sent();
                        if (!!deviceId) return [3 /*break*/, 3];
                        return [4 /*yield*/, getStoredItemFromCookie(DeviceIdKey)];
                    case 2:
                        deviceId = _a.sent();
                        deviceIdWasInCookies = Boolean(deviceId);
                        _a.label = 3;
                    case 3:
                        deviceIdWasGenerated = false;
                        if (!deviceId) {
                            deviceId = deviceIdGenerator.generateDeviceId(DeviceIdPrefix);
                            deviceIdWasGenerated = true;
                        }
                        if (!(deviceIdWasGenerated || !deviceIdWasInCookies)) return [3 /*break*/, 5];
                        return [4 /*yield*/, setDeviceId(deviceId)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/, deviceId];
                }
            });
        });
    }
    function setDeviceId(deviceId) {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, Promise.all([
                                setStoredItemInLocalStorage(DeviceIdKey, deviceId),
                                setStoredItemInCookies(DeviceIdKey, deviceId, opts.cookieDomain, Number.MAX_SAFE_INTEGER, 'lax'),
                            ])];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function getUserId() {
        return __awaiter(this, void 0, void 0, function () {
            var storedAuthUserData, _a, authUserData, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, getStoredItemFromLocalStorage(AuthTokenKey)];
                    case 2:
                        _a = (_b.sent());
                        if (_a) return [3 /*break*/, 4];
                        return [4 /*yield*/, getStoredItemFromCookie(AuthTokenKey)];
                    case 3:
                        _a = (_b.sent());
                        _b.label = 4;
                    case 4:
                        storedAuthUserData = _a;
                        if (!storedAuthUserData) {
                            return [2 /*return*/, undefined];
                        }
                        authUserData = JSON.parse(storedAuthUserData);
                        return [2 /*return*/, authUserData === null || authUserData === void 0 ? void 0 : authUserData.id];
                    case 5:
                        e_1 = _b.sent();
                        return [2 /*return*/, undefined];
                    case 6: return [2 /*return*/];
                }
            });
        });
    }
    function getPartnerId() {
        return __awaiter(this, void 0, void 0, function () {
            var storedPartner, _a, partnerData, e_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, getStoredItemFromLocalStorage(PartnerKey)];
                    case 2:
                        _a = (_b.sent());
                        if (_a) return [3 /*break*/, 4];
                        return [4 /*yield*/, getStoredItemFromCookie(PartnerKey)];
                    case 3:
                        _a = (_b.sent());
                        _b.label = 4;
                    case 4:
                        storedPartner = _a;
                        if (!storedPartner) {
                            return [2 /*return*/, undefined];
                        }
                        partnerData = JSON.parse(storedPartner);
                        return [2 /*return*/, partnerData === null || partnerData === void 0 ? void 0 : partnerData.id];
                    case 5:
                        e_2 = _b.sent();
                        return [2 /*return*/, undefined];
                    case 6: return [2 /*return*/];
                }
            });
        });
    }
    function screenInfo() {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_e) {
                return [2 /*return*/, {
                        width: (_a = window === null || window === void 0 ? void 0 : window.screen) === null || _a === void 0 ? void 0 : _a.width,
                        height: (_b = window === null || window === void 0 ? void 0 : window.screen) === null || _b === void 0 ? void 0 : _b.height,
                        orientation: (_d = (_c = window === null || window === void 0 ? void 0 : window.screen) === null || _c === void 0 ? void 0 : _c.orientation) === null || _d === void 0 ? void 0 : _d.type,
                    }];
            });
        });
    }
    function osInfo() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var os;
            return __generator(this, function (_c) {
                os = uaParser.getOS();
                return [2 /*return*/, {
                        name: (_a = os.name) !== null && _a !== void 0 ? _a : (_b = window === null || window === void 0 ? void 0 : window.navigator) === null || _b === void 0 ? void 0 : _b.platform,
                        version: window.navigator.platform,
                    }];
            });
        });
    }
    function deviceInfo() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, uaParser.getDevice()];
            });
        });
    }
    function browserInfo() {
        return __awaiter(this, void 0, void 0, function () {
            var browser;
            return __generator(this, function (_a) {
                browser = uaParser.getBrowser();
                return [2 /*return*/, __assign({ userAgent: window.navigator.userAgent }, browser)];
            });
        });
    }
    function getEmbeddedDomain(embeddedOptions) {
        if ((embeddedOptions === null || embeddedOptions === void 0 ? void 0 : embeddedOptions.identifier) && (embeddedOptions === null || embeddedOptions === void 0 ? void 0 : embeddedOptions.embeddedDomain)) {
            return embeddedOptions.embeddedDomain;
        }
        return undefined;
    }
    function fetch(input, init) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (typeof window.fetch !== 'function') {
                    throw new Error('client has no `window.fetch`');
                }
                return [2 /*return*/, window.fetch(input, init)];
            });
        });
    }
    return {
        type: function () { return WebPlatform.name; },
        getDeviceId: getDeviceId,
        getUserId: getUserId,
        getPartnerId: getPartnerId,
        screenInfo: screenInfo,
        osInfo: osInfo,
        deviceInfo: deviceInfo,
        browserInfo: browserInfo,
        getEmbeddedDomain: getEmbeddedDomain,
        fetch: fetch,
    };
}
exports.WebPlatform = WebPlatform;
//# sourceMappingURL=web-platform.js.map